export const BUCKET_SETTINGS_LIFECYCLE_GET_SUCCESS =
    'BUCKET_SETTINGS_LIFECYCLE_GET_SUCCESS';
export const BUCKET_SETTINGS_LIFECYCLE_GET_FAILURE =
    'BUCKET_SETTINGS_LIFECYCLE_GET_FAILURE';
export const BUCKET_SETTINGS_LIFECYCLE_GET_REQUEST =
    'BUCKET_SETTINGS_LIFECYCLE_GET_REQUEST';
export const BUCKET_SETTINGS_LIFECYCLE_SET_SUCCESS =
    'BUCKET_SETTINGS_LIFECYCLE_SET_SUCCESS';
export const BUCKET_SETTINGS_LIFECYCLE_SET_FAILURE =
    'BUCKET_SETTINGS_LIFECYCLE_SET_FAILURE';
export const BUCKET_SETTINGS_LIFECYCLE_SET_REQUEST =
    'BUCKET_SETTINGS_LIFECYCLE_SET_REQUEST';
